export enum Messages {
  errorPassword = "Sorry, failed to change password",
  errorNeedVerification = "Sorry, you need to verify your account first, check your email.",
  errorEmptyFields = "Please fill in all fields",
  errorInvalidCredentials = "Email or password is incorrect",
  successPassword = "Password changed successfully. Login to start using VetNebula app.",
  successLoginCode = "A single time code was sent to your email.",
  errorInvalidLoginCode = "Invalid code provided, please check and try again or request a new code.",
  successSetPassword = "Password created successfully. Login to start using VetNebula app.",
  errorSetPassword = "Invalid code provided, please request a code again.",
  successUpdateUser = "User updated successfully",
  successCreateUser = "User created successfully",
  successResetPasswordRequest = "An email was sent to you with the instructions to finish resetting your email.",
  errorCreateUser = "Something went wrong while creating the user, please try again later",
  errorUpdateUser = "Something went wrong while updating the user, please try again later",
  successEditPost = "Post changed successfully",
  successCreatePost = "Post created successfully",
  successUpdateOrganization = "Organization updated successfully",
  successSubmittedBugReportOrSuggestion = "Thank you for your feedback, we will review it as soon as possible.",
  successUpdateQuotation = "Quotation Request updated successfully",
  successSubmittingQuotationForManagersApproval = "Quotation Request submitted successfully",
  errorCreateQuotation = "Something went wrong while requesting the quotation, please check your data and try again later",
  errorImageUpload = "Sorry, failed to upload the image.",
  errorResourceUpload = "Sorry, failed to upload the resource.",
  errorInvalidImageType = "Invalid file type: only PNG and JPEG are allowed",
  error = "Invalid file type: only PNG and JPEG are allowed",
  errorImageSize = "File size is too large: max size is 10MB",
  errorImageFile = "Sorry, failed to upload the file",

  successOrganizationCreated = "Organization created successfully",
  successOrganizationUpdated = "Organization updated successfully",
  successOrganizationDeleted = "Organization deleted successfully",

  successResourceCreated = "Resource created successfully",
  successResourceUpdated = "Resource updated successfully",
  successResourceDeleted = "Resource deleted successfully",

  successTagCreated = "Tag created successfully",
  successTagUpdated = "Tag updated successfully",
  successTagDeleted = "Tag deleted successfully",

  successUserCreated = "User created successfully",
  successUserUpdated = "User updated successfully",
  successUserAcceptedTermsOfUsage = "Thank you for accepting the terms of usage",
  successUserDeleted = "User deleted successfully",
  errorUserCreated = "Something went wrong while creating the user, please try again later",
  errorUserUpdated = "Something went wrong while updating the user, please try again later",
  errorUserDeleted = "Something went wrong while deleting the user, please try again later",

  successAcademicYearCreated = "Academic year created successfully",
  successAcademicYearUpdated = "Academic year updated successfully",
  successAcademicYearDeleted = "Academic year deleted successfully",
  errorAcademicYearCreated = "Something went wrong while creating the program, please try again later",
  errorAcademicYearUpdated = "Something went wrong while updating the program, please try again later",
  errorAcademicYearDeleted = "Something went wrong while deleting the program, please try again later",

  successRequirementCreated = "Requirement created successfully",
  successRequirementUpdated = "Requirement updated successfully",
  successRequirementDeleted = "Requirement deleted successfully",
  errorRequirementCreated = "Something went wrong while creating the requirement, please try again later",
  errorRequirementUpdated = "Something went wrong while updating the requirement, please try again later",
  errorRequirementDeleted = "Something went wrong while deleting the requirement, please try again later",

  successSpeciesCreated = "Species created successfully",
  successSpeciesUpdated = "Species updated successfully",
  successSpeciesDeleted = "Species deleted successfully",

  successDomainCreated = "Domain created successfully",
  successDomainUpdated = "Domain updated successfully",
  successDomainDeleted = "Domain deleted successfully",
  errorSpeciesCreated = "Something went wrong while creating the species, please try again later",
  errorSpeciesUpdated = "Something went wrong while updating the species, please try again later",
  errorSpeciesDeleted = "Something went wrong while deleting the species, please try again later",

  successSiteCreated = "Site created successfully",
  successSiteUpdated = "Site updated successfully",
  successSiteDeleted = "Site deleted successfully",
  errorSiteCreated = "Something went wrong while creating the site, please try again later",
  errorSiteUpdated = "Something went wrong while updating the site, please try again later",
  errorSiteDeleted = "Something went wrong while deleting the site, please try again later",

  successGraduationClassCreated = "Graduation class created successfully",
  successGraduationClassUpdated = "Graduation class updated successfully",
  successGraduationClassDeleted = "Graduation class deleted successfully",
  errorGraduationClassCreated = "Something went wrong while creating the graduation class, please try again later",
  errorGraduationClassUpdated = "Something went wrong while updating the graduation class, please try again later",
  errorGraduationClassDeleted = "Something went wrong while deleting the graduation class, please try again later",
}

export enum LoginResponseType {
  ACTION_REQUIRED = "ACTION_REQUIRED",
  SUCCESS = "SUCCESS",
}

export enum LoginSteps {
  CONTINUE_SIGN_IN_WITH_MFA_SELECTION = "CONTINUE_SIGN_IN_WITH_MFA_SELECTION",
  CONTINUE_SIGN_IN_WITH_TOTP_SETUP = "CONTINUE_SIGN_IN_WITH_TOTP_SETUP",
  CONFIRM_SIGN_IN_WITH_SMS_CODE = "CONFIRM_SIGN_IN_WITH_SMS_CODE",
  CONFIRM_SIGN_IN_WITH_TOTP_CODE = "CONFIRM_SIGN_IN_WITH_TOTP_CODE",
  CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE = "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE",
  CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED = "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED",
  CONFIRM_SIGN_UP = "CONFIRM_SIGN_UP",
  RESET_PASSWORD = "RESET_PASSWORD",
  DONE = "DONE",
}

export enum RequestFeedbackSteps {
  titleRequest = "Request Case Feedback",
  infoRequest = "The Feedback Request will not be initiated to your selected coach until you officially submit this form at Step 7",
  titlePrepare = "Prepare by Reflecting on and Communicating Your Goals",
  alertPrepare = "When you click on Begin, you must complete the procedure and submit this feedback form within the time allotted as indicated on the bottom left. If you fail to do so within the allotted time you mus request a new feedback form and restart the process all over again.",
  titlePerform = "Perform the Skill",
  titleSkill = "Perform the Skill",
  question1Reflect = "What went well? What would be better next time?",
  question2Reflect = "If you were to perform this same EPA again, what level of supervision would you require?",
  question3Reflect = "Is your Coach currently available to provide feedback to you in-person?",
  titleDiscuss = "Ask for Clarification and Suggestions for Improvement",
  questionFocusFeedback = "What would you like your coach to focus their feedback on?",
  question1ReflectCoach = "What is your Coach's feedback on your performance?",
  question2ReflectCoach = "ask your coach to evaluate your performance",
  question1ReflectCoachDetail = "What is your feedback on the performance of the learner?",
  question2ReflectCoachDetail = "How would you rate the skill level of the learner for this observed competency?",
  /** Coach-initiated Give Feedback copy */
  titleGiveFeedback = "Observe, Reflect and Plan",
  reminderGiveFeedback = "Need a reminder? Review the goals and success rubric of the skill you selected to evaluate.",
  questionFocusFeedbackGive = "What will be the feedback focus?",
  guideGiveFeedback = "Here are some suggestions to guide your feedback:",
  guideObserveGive = "What did you observe?",
  guideChangeGive = "What can the learner change next time?",
  guidePlanGive = "What is the plan for next time to implement/practice the change?",
  guideFocusGive = "What specific feedback do you have on",
  sectionGiveFeedback = "Your Feedback",
  submitTitleGiveFeedback = "Submit Feedback",

  titleAskAndPlan = "Ask for Clarification and Plan Next Steps Together",
  titleSubmit = "Submit Feedback Request for Sign-Off",
  descriptionStep1 = "Select the competency skills you would like to be observed by your coach. You can select up to 2 skills.",
  descriptionStep2 = "Prepare by reviewing competency goals.",
  descriptionStep3 = "Perform the skill and reflect on your performance.",
  descriptionStep4 = "Discuss your performance with your coach.",
  descriptionStep5 = "Ask for clarification and suggestions for improvement.",
  descriptionStep6 = "Ask for clarification and plan next steps together.",
  descriptionStep7 = "Submit feedback request.",

  RequestText1 = "Confirm when you worked with this patient by selecting the date and time below.",
  RequestText2 = "You may input the following case details or complete them at a later time prior to form submission.",
}

export enum NotificationSeverity {
  success = "success",
  error = "error",
  warning = "warning",
  info = "info",
}

export enum SortOrder {
  asc = "asc",
  desc = "desc",
}

export enum TABLE_ACTIONS {
  ARCHIVE = "Archive",
  EDIT = "Edit",
  DELETE = "Delete",
  VIEW = "View",
  EMAIL_INVITE = "Email invite",
  VIEW_FULL_PROFILE = "View full profile",
  SELECT_ORGANIZATION = "Select organization",
  RETRY = "Retry",
  REQUEST_FEEDBACK = "Request Feedback",
  GIVE_FEEDBACK = "Give Feedback",
  VIEW_ANSWERS = "View Answers",
  ANSWER_SURVEY = "Answer Survey",
}

export enum ENTITIES {
  USERS = "users",
  VENDORS = "vendors",
}

export enum UPLOAD_FILE_MODAL {
  TITLE = "Upload File",
  TEMPLATE_EXAMPLE = "CSV Format Required",
  TEMPLATE_EXAMPLE_DESCRIPTION = `
  Required columns:

  * \`name\` - Learner name
  * \`email\` - Learner email

  Example:
  
  \`\`\`
  name,email
  John Doe,john.doe@example.com
  Jane Smith,jane.smith@example.com
  \`\`\`
  `,

  TEMPLATE_EXAMPLE_DESCRIPTION_ADMIN = `
  Required columns:

  * \`name\` - User name
  * \`email\` - User email
  * \`role\` - User role

  Example:
  
  \`\`\`
  name,email,role
  John Doe,john.doe@example.com,student
  Jane Smith,jane.smith@example.com,coach
  \`\`\`
  `,

  TEMPLATE_EXAMPLE_DESCRIPTION_PROGRAMS = `
  Required columns:

  * \`name\` - Program name (academic year)
  * \`start_date\` - Start date in YYYY-MM-DD
  * \`end_date\` - End date in YYYY-MM-DD
  * \`requirements\` - Requirement names separated by semicolon \`;\`

  Example:
  
  \`\`\`
  name,start_date,end_date,requirements
  AY 2026,2026-01-01,2026-12-31,EPA 1;EPA 2;EPA 3
  \`\`\`
  `,

  TEMPLATE_EXAMPLE_DESCRIPTION_COHORTS = `
  Required columns:

  * \`name\` - Cohort name
  * \`program_id\` - Program UUID
  * \`start_date\` - Start date in YYYY-MM-DD
  * \`academic_year\` - Academic Year UUID

  Example:
  
  \`\`\`
  name,program_id,start_date,academic_year
  Cohort 2026,11111111-1111-1111-1111-111111111111,2026-01-15,22222222-2222-2222-2222-222222222222
  \`\`\`
  `,

  TEMPLATE_EXAMPLE_DESCRIPTION_REQUIREMENTS = `
  One row per requirement (or EPA header rows plus competency rows for EPA imports).

  **Columns:** \`name\`, \`description\`, and six rubric columns (\`rubric1 (Skill Level)\` … \`rubric6 (Skill Level)\`).

  The \`description\` column is the main text field. Tags, resources, task time, and rubric labels are set on the Processing step.
  `,

  TEMPLATE_EXAMPLE_DESCRIPTION_RUBRICS = `
  One row per rubric milestone. The same rubrics are applied to every requirement in the import.

  **Columns:** \`skill_level\`, \`target_achievement_time\`, \`description\`, \`skill_level_label\`, \`target_achievement_time_label\`

  Example:

  \`\`\`
  skill_level,target_achievement_time,description
  2,1,Milestone at end of first year
  3,2,Milestone at end of second year
  \`\`\`
  `,
}

export enum LAYOUT {
  DRAWER_WIDTH = 195,
}

export enum FAKE_TEXT {
  SHORT = "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
  MEDIUM = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  LONG = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  LONG2X = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
}

export const TAG_TYPES = [
  { value: "regular", label: "Regular" },
  { value: "special", label: "Special" },
  { value: "domain", label: "Domain" },
];

export const TAG_COLOR = (key: string) => {
  switch (key) {
    case "regular":
      return "primary";
    case "special":
    case "system":
      return "error";
    case "domain":
      return "success";
    default:
      return "warning";
  }
};

export enum REQUIREMENT {
  REQUIREMENT_COMPETENCY = "COMPETENCY",
  REQUIREMENT_EPA = "EPA",
  REQUIREMENT_ITER = "ITER",
}

export const enum ALERT_TYPES {
  FEEDBACK_REQUEST = "feedback-request",
  FEEDBACK_STATUS_UPDATE = "feedback-status-update",
  COACH_GAVE_FEEDBACK = "coach-gave-feedback",
  BUG_REPORT_SUGGESTION_RECEIVED = "bug-report-suggestion-received",
}

export const enum FEEDBACK_RESPONSE_TIME_CATEGORY {
  FAST = "fast",
  MODERATE = "moderate",
  SLOW = "slow",
  VERY_SLOW = "verySlow",
}

export enum BadgeCriteriaType {
  FEEDBACK_COUNT = "feedback_count",
  FEEDBACK_REQUESTED_COUNT = "feedback_requested_count",
}
